import React from 'react';
import { MainLayout } from 'layouts/MainLayout';
import { Box } from '@mui/material';
import { Permission, Resource } from '@pepperhq/auth-client';

import { TrackingLinksTable } from '../../../components/tracking-links/components/TrackingLinksTable';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getAllLocationTitles } from 'store/locations/locationsSlice';
import { UnlockPremiumUTMBanner } from 'components/tracking-links/components/UnlockPremiumUTMBanner';

// Campaign Links === Tracking Links
export const TrackingLinksPage = () => {
    const { settings } = useAppSelector(state => state.settings);
    const { locations } = useAppSelector(state => state.locations);
    const { claims } = useAppSelector(state => state.auth);
    const dispatch = useAppDispatch();

    // TODO: Add to roles table
    const hasLinksWritePermission = React.useMemo(
        () => claims.hasPermission(Resource.Links, Permission.write),
        [claims]
    );

    React.useEffect(() => {
        getAllLocationTitles(dispatch);
    }, [dispatch]);

    const unlimitedAppLinksEnabled = settings?.links?.unlimitedAppLinksEnabled ?? false;
    const utmParametersEnabled = settings?.links?.utmParametersEnabled ?? false;

    const showUnlockPremiumUTMBanner = React.useMemo(
        () => !unlimitedAppLinksEnabled || !utmParametersEnabled,
        [unlimitedAppLinksEnabled, utmParametersEnabled]
    );

    return (
        <MainLayout
            pageName="Campaign Links"
            pageDescription="Create trackable links to measure campaign performance."
            noScroll
        >
            <Box display="flex" flex={1} flexDirection="column" gap={2} minHeight={0}>
                {showUnlockPremiumUTMBanner && <UnlockPremiumUTMBanner />}
                <TrackingLinksTable
                    hasLinksWritePermission={hasLinksWritePermission}
                    locations={locations}
                    utmParametersEnabled={utmParametersEnabled}
                    unlimitedAppLinksEnabled={unlimitedAppLinksEnabled}
                />
            </Box>
        </MainLayout>
    );
};
